import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var leaveTypeListRes;
export const leaveTypeListTodo = createAsyncThunk('leaveTypeList', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/leave_type_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return leaveTypeListRes = res.data
    } catch (error) {
        return leaveTypeListRes = error.response.data
    }
})


const leaveTypeListSlice = createSlice({
    name: 'leaveTypeList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(leaveTypeListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('leaveTypeList', state.data)
            }
        });
        builder.addCase(leaveTypeListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default leaveTypeListSlice.reducer; 